import { modalStore } from '@/stores/modal.store';
import Image from 'next/image';

const Chevron = () => (
    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 stroke-current fill-none [stroke-width:2.6] [stroke-linecap:round] [stroke-linejoin:round]">
        <path d="M9 6l6 6-6 6" />
    </svg>
);

const MakeDeposit = () => {
    const { data } = modalStore((state) => state);

    return (
        <div className="flex flex-col items-center gap-7 w-[min(540px,90vw)] pt-1">
            <p className="font-chat-msg text-text_2 text-[14px] text-center leading-[1.6] max-w-[440px]">
                Deposit from your <span className="text-text_main font-semibold">Steam</span> or{' '}
                <span className="text-text_main font-semibold">site</span> inventory.
                <br />
                Need skins? Grab them in the marketplace.
            </p>

            <div className="grid grid-cols-2 max-md:grid-cols-1 gap-3.5 w-full">
                {/* Site inventory — cyan */}
                <button
                    onClick={() => data.siteFunc?.()}
                    className="group relative overflow-hidden flex flex-col items-center text-center gap-3 p-6 max-md:p-5 rounded-fl-md border border-stroke bg-white/[0.02] transition-all hover:-translate-y-1 hover:border-[#3ad6ff]/55 hover:bg-[rgba(58,214,255,0.06)] hover:shadow-[0_14px_34px_-10px_rgba(58,214,255,0.55)]"
                >
                    <span
                        className="absolute top-0 inset-x-0 h-[2px] opacity-60 group-hover:opacity-100 transition-opacity"
                        style={{ background: 'linear-gradient(90deg, transparent, #3ad6ff, #8b6dff, transparent)' }}
                    />
                    <span
                        className="w-14 h-14 grid place-items-center rounded-[28%] transition-transform group-hover:scale-105"
                        style={{
                            background: 'linear-gradient(135deg, rgba(58,214,255,0.22), rgba(139,109,255,0.08))',
                            border: '1px solid rgba(58,214,255,0.4)',
                            color: '#5fe0ff',
                            boxShadow: '0 0 22px -5px rgba(58,214,255,0.65), inset 0 0 14px -6px rgba(58,214,255,0.6)',
                        }}
                    >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7">
                            <rect x="3" y="3" width="7" height="7" rx="1.6" />
                            <rect x="14" y="3" width="7" height="7" rx="1.6" />
                            <rect x="3" y="14" width="7" height="7" rx="1.6" />
                            <rect x="14" y="14" width="7" height="7" rx="1.6" />
                        </svg>
                    </span>
                    <span className="font-chat-nick text-[14px] font-extrabold tracking-[0.07em] text-white">
                        SITE INVENTORY
                    </span>
                    <span className="text-[11.5px] text-text_3 font-medium">
                        Use skins already on the site
                    </span>
                    <span
                        className="mt-0.5 inline-flex items-center gap-1 text-[10.5px] font-bold uppercase tracking-[0.14em] opacity-0 -translate-y-0.5 group-hover:opacity-100 group-hover:translate-y-0 transition-all"
                        style={{ color: '#5fe0ff' }}
                    >
                        Select <Chevron />
                    </span>
                </button>

                {/* Steam inventory — green */}
                <button
                    onClick={() => data.steamFunc?.()}
                    className="group relative overflow-hidden flex flex-col items-center text-center gap-3 p-6 max-md:p-5 rounded-fl-md border border-stroke bg-white/[0.02] transition-all hover:-translate-y-1 hover:border-[#46e08a]/55 hover:bg-[rgba(70,224,138,0.06)] hover:shadow-[0_14px_34px_-10px_rgba(70,224,138,0.55)]"
                >
                    <span
                        className="absolute top-0 inset-x-0 h-[2px] opacity-60 group-hover:opacity-100 transition-opacity"
                        style={{ background: 'linear-gradient(90deg, transparent, #46e08a, transparent)' }}
                    />
                    <span
                        className="w-14 h-14 grid place-items-center rounded-[28%] transition-transform group-hover:scale-105"
                        style={{
                            background: 'linear-gradient(135deg, rgba(70,224,138,0.22), rgba(70,224,138,0.05))',
                            border: '1px solid rgba(70,224,138,0.4)',
                            boxShadow: '0 0 22px -5px rgba(70,224,138,0.65), inset 0 0 14px -6px rgba(70,224,138,0.6)',
                        }}
                    >
                        <Image src="/icons/steam.svg" alt="" width={26} height={26} className="opacity-95" />
                    </span>
                    <span className="font-chat-nick text-[14px] font-extrabold tracking-[0.07em] text-white">
                        STEAM INVENTORY
                    </span>
                    <span className="text-[11.5px] text-text_3 font-medium">
                        Deposit directly from Steam
                    </span>
                    <span
                        className="mt-0.5 inline-flex items-center gap-1 text-[10.5px] font-bold uppercase tracking-[0.14em] opacity-0 -translate-y-0.5 group-hover:opacity-100 group-hover:translate-y-0 transition-all"
                        style={{ color: '#7ff0b5' }}
                    >
                        Select <Chevron />
                    </span>
                </button>
            </div>
        </div>
    );
};

export default MakeDeposit;
